import ajax from '../../common/services/httpService';
const BASE_URL = 'shift';

/**
 * @typedef {{
 * arrivals_percent: Number;
 * arrivals_percent_no_visits: Number;
 * complaints_percent: Number;
 * complaints_percent_no_visits: Number;
 * day_arrivals: Number;
 * end_hour: Number;
 * id: Number;
 * max_sla: Number;
 * min_sla: Number;
 * save_arrivals: Number;
 * shift_name: String;
 * shift_number: Number;
 * sla_percent: Number;
 * sla_percent_no_visits: Number;
 * start_hour: Number;
 * week_arrivals: String; //stringified array
 * }} Shift
 */

/**
 * @param {String | Number} site_id
 * @param {String | Number} [room_id]
 * @returns {Promise<Shift[]>}*/
async function getShifts(site_id, room_id) {
    const query = { site_id }
    if (room_id) query.room_id = room_id
    const shifts = await ajax.get(BASE_URL, null, query)
    return shifts
}

/** @param {Shift} shift */
async function saveShift(shift) {
    if (shift.id) {
        const res = await ajax.put(BASE_URL, shift);
        return res;
    } else {
        const res = await ajax.post(BASE_URL, shift);
        return res;
    }
}

/**
 * Returns the current shift for the site based on the company's configured timezone (server-side).
 * When multiple shifts match the current hour, the response includes currentShifts with all concurrent matches.
 * @param {Number} site_id
 * @returns {Promise<(Shift & { currentShifts?: Shift[] })|null>}
 */
async function getCurrentShift(site_id, options = {}) {
    const shift = await ajax.get(BASE_URL + '/current', null, { siteId: site_id }, options);
    return shift;
}

/**@param {String | Number} id */
async function removeShift(id,roomId = null) {
    const res = await ajax.delete(BASE_URL, { id, roomId })
    return res;
}

export default {
    getShifts,
    saveShift,
    removeShift,
    getCurrentShift
}